/*
 * $Id:: RequestResult.js 2021/01/20 05:42 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { t } from '../../../providers';

const useStyles = makeStyles(() => ({
    requestResultWrapper: {
        marginTop: '10px',
        display: 'flex',
        flexFlow: 'column nowrap',
    },
    inputWrapper: {
        marginBottom: '1.9rem',
    },
    message: {
        maxWidth: '37.5rem',
    },
    requestResultSubmit: {
        '@media (max-width:320px)': {
            width: '11rem',
            fontSize: '75%',
        },
    },
}));

const RequestResult = ({ action, message, button, messageVariables = {} }) => {
    const classes = useStyles();
    const submit = (event) => {
        event.preventDefault();
        action();
    };

    return (
        <div className={classes.requestResultWrapper}>
            <Grid container direction="column" className={classes.inputWrapper}>
                <Grid item>
                    <Typography variant="body2" className={classes.message}>
                        {t(message, messageVariables)}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container spacing={0}>
                <Grid item>
                    <Button
                        variant="contained"
                        onClick={submit}
                        className={classes.requestResultSubmit}
                        style={{ textTransform: 'none' }}
                        type="button">
                        {t(button)}
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
};

export default RequestResult;
